import { env } from "@/config";
import { getSelectedSessionId } from "@/sdk";
import { getSharedApiClient } from "@/shared-utils";

export function getChatMetadataApiClient() {
    return getSharedApiClient(getSelectedSessionId()).extend(() => ({
        prefix: `${env.backendUrls.apiBaseUrl}/api/chat-metadata`,
    }));
}
